import { render, staticRenderFns } from "./df-nav-item.vue?vue&type=template&id=73c95c0e&scoped=true"
import script from "./df-nav-item.vue?vue&type=script&lang=js"
export * from "./df-nav-item.vue?vue&type=script&lang=js"
import style0 from "./df-nav-item.vue?vue&type=style&index=0&id=73c95c0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c95c0e",
  null
  
)

export default component.exports